import { connect } from 'react-redux';

import ArtifactHealthOrderComponent from
  '../Components/ArtifactHealthOrderComponent';
import { changeArtifactHealthOrder } from '../actions';
import { artifactHealth } from '../helpers';

export const mapStateToProps = () => {
  return { orders: Object.keys(artifactHealth.ARTIFACT_HEALTH_ORDERS) };
};

export default connect(
  mapStateToProps,
  { onOrderChange: changeArtifactHealthOrder }
)(ArtifactHealthOrderComponent);


// WEBPACK FOOTER //
// src/Containers/ArtifactHealthOrderContainer.jsx